import Swiper from "swiper/bundle";

const getOffset = () => {
  const container = document.querySelector(".container");
  const viewportWidth = window.innerWidth;
  const offset = (viewportWidth - container.offsetWidth) / 2;
  return offset + 15;
};

// init Swiper:
export const initSwiper = (options) => {
  const defaults = {
    slidesOffsetBefore: getOffset(),
    selector: ".swiper",
    slidesPerView: 1.2,
    spaceBetween: 15,
    breakpoints: {
      "@0.75": {
        slidesPerView: 2.2,
      },
      "@1.00": {
        slidesPerView: 3.2,
      },
    },
  };
  const {
    slidesOffsetBefore,
    selector,
    slidesPerView,
    spaceBetween,
    breakpoints,
  } = {
    ...defaults,
    ...options,
  };

  new Swiper(selector, {
    // configure Swiper to use modules
    //  modules: [Navigation, Pagination],
    //  // If we need pagination
    //  pagination: {
    //    el: ".swiper-pagination",
    //  },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    slidesPerView,
    spaceBetween,
    // using "ratio" endpoints
    breakpoints,
    slidesOffsetBefore,
  });
};

// blog gallery with thumbs
export function initializeGalleries() {
  var galleries = document.querySelectorAll(".image-gallery");

  if (galleries.length === 0) return;

  galleries.forEach(function (gallery) {
    var galleryId = gallery.id;
    var mainSwiper = gallery.querySelector(
      '[data-gallery-main="' + galleryId + '"]',
    );
    var thumbsSwiper = gallery.querySelector(
      '[data-gallery-thumbs="' + galleryId + '"]',
    );

    if (!mainSwiper || !thumbsSwiper) return;

    // Initialize thumbnails swiper first
    var swiperThumbs = new Swiper(thumbsSwiper, {
      spaceBetween: 10,
      slidesPerView: 4,
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 4,
        },
      },
      on: {
        click: function (swiper, event) {
          // Handle thumb click to change main slider
          var clickedSlide = event.target.closest(".swiper-slide");
          if (clickedSlide) {
            var slideIndex = Array.from(
              clickedSlide.parentNode.children,
            ).indexOf(clickedSlide);
            swiperMain.slideTo(slideIndex);
          }
        },
      },
    });

    // Initialize main swiper
    var swiperMain = new Swiper(mainSwiper, {
      spaceBetween: 10,
      slidesPerView: 1,
      effect: "slide",
      // auto height
      autoHeight: true,
      navigation: {
        nextEl: mainSwiper.querySelector(".swiper-next-fixed"),
        prevEl: mainSwiper.querySelector(".swiper-prev-fixed"),
      },
      thumbs: {
        swiper: swiperThumbs,
      },
      on: {
        slideChange: function (swiper) {
          // Update active thumb when main slider changes
          updateActiveThumb(swiper.activeIndex);
        },
        init: function (swiper) {
          // Set initial active thumb
          updateActiveThumb(swiper.activeIndex);
        },
      },
    });

    // Function to update active thumb class
    function updateActiveThumb(activeIndex) {
      // Remove active class from all thumbs
      var allThumbs = thumbsSwiper.querySelectorAll(".swiper-slide");
      allThumbs.forEach(function (thumb) {
        thumb.classList.remove("active-thumb");
      });

      // Add active class to current thumb
      if (allThumbs[activeIndex]) {
        allThumbs[activeIndex].classList.add("active-thumb");
      }
    }
  });
}
